const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.avi', '.mkv', '.m4v'];

export function isVideoUrl(url: string): boolean {
  if (!url) return false;
  const lower = url.toLowerCase().split('?')[0]; // strip query params
  return VIDEO_EXTENSIONS.some(ext => lower.endsWith(ext));
}

export const ACCEPTED_IMAGE_TYPES = {
  'image/*': ['.jpeg', '.jpg', '.png', '.webp'],
};

export const ACCEPTED_MEDIA_TYPES = {
  'image/*': ['.jpeg', '.jpg', '.png', '.webp'],
  'video/*': ['.mp4', '.webm', '.mov'],
};

export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
export const MAX_VIDEO_SIZE = 50 * 1024 * 1024; // 50MB
